import React from 'react'
import { CloseIcon } from '../../search-spring/ui-components/Icons'
import { Facet, Sorting } from '../../search-spring/types/types'
import FilterItems from './FilterItems'
import SortingFilter from './SortingFilter'
import useWindowSize from '../../search-spring/customHooks/useWindowSize'
import MobileFilterFactory from './MobileFilterFactory'
import { clearFilterParams } from '../helpers/clearFilters'

type Props = {
  filters: Facet[]
  sorting: Sorting
  triggerSearch: (payloadValues?: { fieldValue: string; optionValues: string[] }[]) => void
  activeFilters: number
}

type FilterBuilderProps = {
  filters: Facet[]
  sorting: Sorting
  triggerFilterSearch: () => void
  clearFiltersAndResetSearch: () => void
  activeFilters: number
}

  const toggleFilters = (): void => {
    const filterContainer = document.getElementById('filterContainer')
    const overlay = document.getElementById('overlay')
    const body = document.body;

    if (filterContainer && overlay) {
      const isHidden = filterContainer.classList.contains('translate-y-full')
  
      if (isHidden) {
        filterContainer.classList.remove('translate-y-full')
        filterContainer.classList.add('translate-y-0')
      } else {
        filterContainer.classList.remove('translate-y-0')
        filterContainer.classList.add('translate-y-full')
      }
  
      overlay.classList.toggle('hidden')
      body.classList.toggle('overflow-hidden')
    }
  }

  const FilterBuilder = ({filters, sorting, triggerFilterSearch, clearFiltersAndResetSearch, activeFilters}: FilterBuilderProps): JSX.Element => {
    const window = useWindowSize()
    const isMobile = window.width <= 1023

    if (isMobile) {
      return <>
        <div className="flex items-center justify-between p-5">
          <p className="text-sm uppercase font-bstSpyre">filter
          {activeFilters > 0 && (
            <sup className="text-xxs font-light ml-1 top-[-0.2em]">({activeFilters})</sup>
          )}
          </p>
          <CloseIcon onClick={toggleFilters} />
        </div>

        <MobileFilterFactory filters={filters} sorting={sorting} />

        <div className="items-center justify-end p-5 mt-auto border-t border-border-secondary">
          <button onClick={triggerFilterSearch} className="w-full h-[35px] Button Button--tertiary uppercase mb-SM">
            {activeFilters > 1 ? 'apply filters' : 'apply filter'} {activeFilters > 0 && `(${activeFilters})`}
          </button>
          <p onClick={clearFiltersAndResetSearch} className="uppercase font-calibre text-sm-b underline text-center underline-offset-[6px] text-black">clear all</p>
        </div>
      </>
    } else {
      return <>
      <div className="flex items-center justify-between p-5">
        <p className="text-sm uppercase font-bstSpyre">filter
        {activeFilters > 0 && (
            <sup className="ml-1 text-xs font-light !-top-1">({activeFilters})</sup>
          )}
        </p>
        <CloseIcon onClick={toggleFilters} />
      </div>
      
      <div className="flex flex-row justify-between overflow-x-auto">
        {/* Filters */}
        <FilterItems filters={filters} />
        {/* Sorting */}
        <SortingFilter sorting={sorting} />
      </div>

      <div className="flex items-center justify-end p-5">
        <p onClick={clearFiltersAndResetSearch} className="cursor-pointer uppercase font-calibre text-sm-b underline mr-SM underline-offset-[6px] text-black">clear all</p>
        <button onClick={triggerFilterSearch} className="Button Button--tertiary uppercase">
          {activeFilters > 1 ? 'apply filters' : 'apply filter'} {activeFilters > 0 && `(${activeFilters})`}
        </button>
      </div>
    </>
    }
  }
  

const Filter = ({filters, sorting, activeFilters}: Props): JSX.Element => {

  const triggerFilterSearch = (): void => {
    document.body.classList.remove('overflow-hidden')
    const urlChangeEvent = new CustomEvent('urlChange', { detail: {} })
    window.dispatchEvent(urlChangeEvent)
  }

  const clearFiltersAndResetSearch = (): void => {
    clearFilterParams()
    document.body.classList.remove('overflow-hidden')
    const urlChangeEvent = new CustomEvent('urlChange', { detail: {} })
    window.dispatchEvent(urlChangeEvent)
  }

  return (
    <>
      <button onClick={toggleFilters} className="Button Button--secondary-dark uppercase backdrop-filter-none max-w-[150px] min-w-[150px] font-calibre text-sm-b text-black hover:text-white border-secondary whitespace-nowrap py-0 min-h-[30px]">{`Filter${activeFilters > 0 ? ` (${activeFilters})` : ''}`}</button>
      <div id="overlay" className="fixed inset-0 z-40 hidden bg-black bg-opacity-30" onClick={toggleFilters}></div>
      <div id="filterContainer" className="fixed bottom-0 left-0 w-full h-dvh bg-white z-50 flex flex-col overflow-scroll transform translate-y-full transition-transform duration-500 ease-in-out md:gap-5 md:justify-between lg:h-auto">
        <FilterBuilder filters={filters} sorting={sorting} triggerFilterSearch={triggerFilterSearch} clearFiltersAndResetSearch={clearFiltersAndResetSearch} activeFilters={activeFilters} />
      </div>
    </>
  )
}

export default Filter